<template>
  <div>
    <div class="align-left">
      <p>
        I have worked with early-stage startups for over 6 years now, and remotely for the last half of that. My programming career began at a startup studio based in Vancouver, Canada, where I worked with several startups in varying industries. I love the challenging, fast-paced growth and endless opportunities that this environment provides, as well as the enthusiasm of others that tend to float around the startup space.
      </p>

      <p>
        I work across the full stack, but focus more on the backend, as I am more excited by building a functional and reliable system.
      </p>

      <p>
        I also pick up contract work on the occassion, and have worked as a Teaching Assistant at <a href="https://www.lighthouselabs.ca/">Lighthouse Labs</a>, a Canadian web development bootcamp.
      </p>

      <div class="pure-g experience-section">
        <div class="logo pure-u-1 pure-u-sm-1-4">
          <a href="https://layerth.com">
            <img src="../assets/layerth.png">
          </a>
        </div>
        <div class="pure-u-1 pure-u-sm-3-4">
          <p>My current team.</p>
          <p>
            We build e-sports broadcasting software, specifically for spectator-friendly events such as tournaments. Our projects range from real-time games played by spectators during events, to overlay data that displays analytics and statistics from a game as it happens.
          </p>
        </div>
      </div>

      <div class="pure-g experience-section">
        <div class="logo pure-u-1 pure-u-sm-1-4">
          <a href="http://botpress.com">
            <img src="../assets/botpress.svg">
          </a>
        </div>
        <div class="pure-u-1 pure-u-sm-3-4">
          <p>
            Built the alpha version of the cloud deployment manager - a platform for migrating chatbots from the core on-premise solution to the cloud.
          </p>
        </div>
      </div>

      <div class="pure-g experience-section">
        <div class="logo pure-u-1 pure-u-sm-1-4">
          <a href="https://bluemesahealth.com">
            <img src="../assets/bluemesa.png">
          </a>
        </div>
        <div class="pure-u-1 pure-u-sm-3-4">
          <p>
            Blue Mesa Health (acquired by Virgin Pulse) is a digital therapeutics company. I contributed to the core product here, Transform, which is a digital diabetes prevention program delivered via a mobile application. As the first employee at BMH, I had an incredible experience watching this company grow from an idea, to expanding internationally. I also mentored juniors, and led and owned several engineering projects.
          </p>
        </div>
      </div>

      <div class="pure-g experience-section">
        <div class="logo pure-u-1 pure-u-sm-1-4">
          <a href="https://lighthouselabs.ca">
            <img src="../assets/lhl.png" class="logo">
          </a>
        </div>
        <div class="pure-u-1 pure-u-sm-3-4">
          <p>
            Having completed this bootcamp myself, I was grateful to be able to give back to the local tech community as a Teaching Assistant at Lighthouse Labs. During my time, I provided mentorship to students by answering questions and providing guidance on how to solve their assignments, mid-term and final projects, as well as sharing my experience in the startup industry.
          </p>
        </div>
      </div>

      <div class="pure-g experience-section">
        <div class="logo pure-u-1 pure-u-sm-1-4">
          <a href="https://stanleyparkventures.com">
            <img src="../assets/spv.png">
          </a>
        </div>
        <div class="pure-u-1 pure-u-sm-3-4">
          <p>
            I first dived into the startup world in 2014, when I joined <a href="https://stanleyparkventures.com">Stanley Park Ventures</a>, a startup studio, based in Vancouver, Canada. At SPV, I worked on internal tools, prototypes and MVPs for the various startups growing in the studio.
          </p>
          <p>
            Some of the startups I worked with during my time at SPV include:
          </p>
          <div class="spv-logos">
            <a href="https://koho.ca"><img src="../assets/koho.png"></a>
            <a href="https://lendful.ca"><img src="../assets/lendful.png"></a>
            <a href="https://alavida.co"><img src="../assets/alavida.png" class="alavida"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Summary',
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.experience-section {
  margin-bottom: 1rem;
}
.logo {
  text-align: center;
}

.logo img {
  width: 80%;
  max-width: 200px;
  margin-top: 1.2rem;
}

.spv-logos {
  text-align: center;
}
.spv-logos img {
  height: 50px;
  margin: 0.5rem 1rem;
  opacity: 0.75;
  transition: all 0.3s ease;
}
.spv-logos img:hover {
  opacity: 1;
}

.spv-logos img.alavida {
  height: 40px;
}
</style>
